import { deletedEntries } from '@/utils/contentful';
import { ComponentRichText, PageAcademyArticleContentItem } from '@cms/graphql/types.generated';
import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { ArticleHeading, ArticleImage, ArticleRichText, ArticleVideo } from './elements';

type Props = {
  elements: PageAcademyArticleContentItem[];
};

const titleElementMap: Options = {
  renderNode: {
    [BLOCKS.HEADING_1]: (_node, children: string) => (
      <ArticleHeading as="h1">{children}</ArticleHeading>
    ),
    [BLOCKS.HEADING_2]: (_node, children: string) => <ArticleHeading>{children}</ArticleHeading>,
    [BLOCKS.HEADING_3]: (_node, children: string) => (
      <ArticleHeading as="h3">{children}</ArticleHeading>
    ),
    [BLOCKS.HEADING_4]: (_node, children: string) => (
      <ArticleHeading as="h4">{children}</ArticleHeading>
    ),
    [BLOCKS.HEADING_5]: (_node, children: string) => (
      <ArticleHeading as="h5">{children}</ArticleHeading>
    ),
    [BLOCKS.HEADING_6]: (_node, children: string) => (
      <ArticleHeading as="h6">{children}</ArticleHeading>
    ),
  },
};

export const ArticleElements = ({ elements }: Props) => (
  <>
    {elements.filter(deletedEntries).map(({ __typename, ...props }, i) => {
      switch (__typename) {
        case 'ComponentTitle':
        case 'ComponentRichText':
          return (
            <ArticleRichText
              {...(props as ComponentRichText)}
              elementMap={titleElementMap}
              key={`article-rich-text-${i}`}
            />
          );
        case 'ComponentImages':
          return <ArticleImage {...props} key={`article-image-${i}`} />;
        case 'ComponentVideo':
          return <ArticleVideo {...props} key={`article-video-${i}`} />;
      }
    })}
  </>
);
